/**
 * Handles responses from Express Validator
 * and places them in to an error array for the
 * specified field used in the argument
 * Place the following in your request catch statement
 *
 * catch(err) {
 *  this.$validator.errors = err.response.data.errors
 * }
 */
module.exports = {
  data() {
    return {
      errors: []
    }
  },
  methods: {
    getErrors(field) {
      if (!this.errors) return
      const fieldErrors = this.errors
        .filter((error) => error.param === field)
        .map((error) => error.msg)
      return fieldErrors
    }
  }
}
